import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { AggregationPeriod } from '@src/types/MerchantStatistic'
import { useTranslation } from 'react-i18next'

interface AggregationToggleProps {
  aggregation: AggregationPeriod
  onAggregationChange: (aggregation: AggregationPeriod) => void
  disableDaily?: boolean
}

export const AggregationToggle = ({ aggregation, onAggregationChange, disableDaily }: AggregationToggleProps) => {
  const { t } = useTranslation()

  return (
    <ToggleButtonGroup
      value={aggregation}
      exclusive
      size="small"
      onChange={(_, newAgg: AggregationPeriod | null) => newAgg && onAggregationChange(newAgg)}
    >
      {Object.values(AggregationPeriod).map((period) => (
        <ToggleButton key={period} value={period} disabled={period === AggregationPeriod.Daily && disableDaily}>
          {t(`merchantStatistics.merchantLoanActivity.${period}` as const)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
